import { TFunction } from 'i18next';
import { PreliminaryInvoiceStatus } from '../interface/invoice';
import { MatterStatus } from './matter';
import { BorderColor, TagColor } from '../interface/common';
import { InvoicingPeriod } from '../interface/parameters';

export const INVOICING_PERIOD_TRANSLATION_KEYS: {
  [key in Exclude<InvoicingPeriod, InvoicingPeriod.NOT_USED>]: string;
} = {
  [InvoicingPeriod.WEEKLY]: 'matter:invoicingPeriod.weekly',
  [InvoicingPeriod.TWICE_A_MONTH]: 'matter:invoicingPeriod.twiceAMonth',
  [InvoicingPeriod.ONCE_A_MONTH]: 'matter:invoicingPeriod.onceAMonth',
  [InvoicingPeriod.EVERY_SECOND_MONTH]: 'matter:invoicingPeriod.everySecondMonth',
  [InvoicingPeriod.EVERY_THIRD_MONTH]: 'matter:invoicingPeriod.everyThirdMonth',
};

export const isInvoicingPeriodInUse = (
  invoicingPeriod: InvoicingPeriod | null | undefined,
): invoicingPeriod is Exclude<InvoicingPeriod, InvoicingPeriod.NOT_USED> =>
  !!invoicingPeriod && invoicingPeriod !== InvoicingPeriod.NOT_USED;

/** Shared by every screen reading the matter-details query, whose cache key ignores these params. */
export const BILLABLE_MATTER_QUERY = {
  withFavoriteInformation: true,
  withHasSubMatters: true,
  withShowOnlyOwnEntries: true,
  relations: [
    'ownerUser:fullName',
    'responsibleUser:fullName',
    'invoicingUser:fullName',
    'principalCompany:name',
    'principalPrivatePerson:fullName',
  ],
  fields: [
    'subject',
    'matterNumber',
    'status',
    'invoiceableType',
    'periodStartDate',
    'periodEndDate',
    'openingDate',
    'language',
    'currency',
    'conflictCheckDoneDate',
    'hasImportantNotes',
    'hasImportantRelatedNotes',
    'hasNotes',
    'sumOfBillableEntries',
    'sumOfBillableEntriesInCurrency',
    'parentMatterId',
    'hasSubMatters',
    'customerIdentificationStatus',
  ],
};

export const renderInvoiceStatus = (
  invoiceStatus: PreliminaryInvoiceStatus | undefined,
  t: TFunction,
  matterStatus: MatterStatus | undefined,
) => {
  if (invoiceStatus) {
    return t(`preliminaryInvoice:status.${invoiceStatus}`);
  } else if (matterStatus) {
    return t(
      matterStatus === MatterStatus.ACTIVE ? 'matter:status.active' : 'matter:status.closed',
    );
  } else return null;
};
export const MatterTagColor: {
  [key in MatterStatus]: TagColor;
} = {
  [MatterStatus.ACTIVE]: TagColor.GREEN,
  [MatterStatus.CLOSED]: TagColor.RED,
};

export const MatterBorderColor: {
  [key in MatterStatus]: string;
} = {
  [MatterStatus.ACTIVE]: BorderColor.GREEN,
  [MatterStatus.CLOSED]: BorderColor.RED,
};
export const PreliminaryInvoiceStatusTagColor: {
  [key in PreliminaryInvoiceStatus]: TagColor;
} = {
  [PreliminaryInvoiceStatus.OPEN]: TagColor.GREEN,
  [PreliminaryInvoiceStatus.REVIEWED]: TagColor.DARKGREY,
  [PreliminaryInvoiceStatus.UPLIFT_DOWNLIFT]: TagColor.PURPLE,
  [PreliminaryInvoiceStatus.APPROVED]: TagColor.BEIGE,
  [PreliminaryInvoiceStatus.REJECTED]: TagColor.RED,
  [PreliminaryInvoiceStatus.INVOICED]: TagColor.YELLOW,
};

export const PreliminaryInvoiceStatusBorderColor: {
  [key in PreliminaryInvoiceStatus]: string;
} = {
  [PreliminaryInvoiceStatus.OPEN]: BorderColor.GREEN,
  [PreliminaryInvoiceStatus.REVIEWED]: BorderColor.DARKGREY,
  [PreliminaryInvoiceStatus.UPLIFT_DOWNLIFT]: BorderColor.PURPLE,
  [PreliminaryInvoiceStatus.APPROVED]: BorderColor.BEIGE,
  [PreliminaryInvoiceStatus.REJECTED]: BorderColor.RED,
  [PreliminaryInvoiceStatus.INVOICED]: BorderColor.YELLOW,
};
